import styled from "styled-components";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";

interface CounselorProps {
  counselor: {
    image: string;
    name: string;
    description: string;
    social: {
      linkedin: string;
      curriculum: string;
    }
  }
};

export function Counselor ({ counselor }: CounselorProps) {
  return (
    <CounselorItem>
      <CounselorImg src={counselor.image} />
      <CounselorName>{ counselor.name }</CounselorName>
      <CounselorDescription>{ counselor.description }</CounselorDescription>
      <Social>
        {counselor.social.linkedin && (
          <SocialLink href={counselor.social.linkedin} target="_blank">
            <FaLinkedinIn size={24} />
          </SocialLink>
        )}
        {counselor.social.curriculum && (
          <SocialLink href={counselor.social.curriculum} target="_blank">
            <BsFillPersonLinesFill size={24} />
          </SocialLink>
        )}
      </Social>
    </CounselorItem>
  );
}

const CounselorItem = styled.li`
  width: 276px;
  margin: 0 20px;
  list-style-type: none;
`;

const CounselorImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 8px;
`;

const CounselorName = styled.span`
  display: block;
  font-size: 32px;
  color: ${({ theme }) => theme.colors.black.dark};
  margin-bottom: 8px;
`;

const CounselorDescription = styled.span`
  font-size: 13px;
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.black.light};
`;

const Social = styled.div`
  display: flex;
  margin-top: 12px;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue.dark};
  border: ${({ theme }) => `2px solid ${theme.colors.blue.dark}`};
  margin-right: 8px;
  padding: 4px;
  border-radius: 2px;
`;